"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var JourneyStepsRoutes_1 = require("../enum/JourneyStepsRoutes");
var globalTypes_1 = require("../../../__generated__/globalTypes");
var JourneyList_1 = require("../components/journeyList/JourneyList");
var BubbleHelpIcon_1 = require("../assets/svg/BubbleHelpIcon");
var CarTvIcon_1 = require("../assets/svg/CarTvIcon");
var CartIcon_1 = require("../assets/svg/CartIcon");
var JourneySummary_1 = require("../components/journeySummary/JourneySummary");
var CustomerInformation_1 = require("../components/customerInformation/CustomerInformation");
var CustomerInformationSummary_1 = require("../components/customerInformationSummary/CustomerInformationSummary");
var FinanceAndInsuranceSummary_1 = require("../components/financeAndInsuranceSummary/FinanceAndInsuranceSummary");
var FinanceAndInsurance_1 = require("../components/financeAndInsurance/FinanceAndInsurance");
var PaymentSummary_1 = require("../components/payment/paymentSummary/PaymentSummary");
var PaymentContainer_1 = require("../components/payment/PaymentContainer");
var IdentityVerificationContainer_1 = require("../components/identityVerification/IdentityVerificationContainer");
var FinanceSection_1 = require("../components/finance/FinanceSection");
var DealerContainer_1 = require("../components/dealer/DealerContainer");
var DealerSummary_1 = require("../components/dealer/dealerSummary/DealerSummary");
var Accesories_1 = require("../components/accesories/Accesories");
var JourneySteps_1 = require("../enum/JourneySteps");
var Extras_1 = require("../components/extras/components/Extras");
var ExpressionOfInterestSummary_1 = require("../components/extras/components/expressionOfInterestSummary/ExpressionOfInterestSummary");
var HeadlessFinanceSection_1 = require("../components/headlessFinance/HeadlessFinanceSection");
var JourneySelectionStep = {
    labelId: 'trans__checkout__your_next_step_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.NEXT_STEPS,
    component: <JourneyList_1.default />,
    summaryComponent: <JourneySummary_1.default />,
};
var AccessoriesStep = {
    labelId: 'Accessories',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.ACCESORIES,
    component: <Accesories_1.default />,
};
var DealerStep = {
    labelId: 'trans__checkout__dealers_page__dealer_step_title',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER,
    component: <DealerContainer_1.default />,
    summaryComponent: <DealerSummary_1.default />,
};
var ExtrasStep = {
    labelId: 'trans__checkout__next_step__extras_step_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.EXTRAS,
    component: <Extras_1.default />,
    summaryComponent: <ExpressionOfInterestSummary_1.default />,
};
var FinanceInsuranceStep = {
    labelId: 'trans__checkout__next_step__order_now__finance_and_insurance_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.FINANCE_INSURANCE,
    component: <FinanceAndInsurance_1.default />,
    summaryComponent: <FinanceAndInsuranceSummary_1.default />,
};
var FinanceStep = {
    labelId: 'trans__checkout__next_step__finance_step_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.FINANCE,
    component: <FinanceSection_1.default />,
};
var HeadlessFinanceStep = {
    labelId: 'trans__checkout__next_step__payment_method_section_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.HEADLESS_FINANCE,
    component: <HeadlessFinanceSection_1.default />,
};
var PaymentStep = {
    labelId: 'trans__checkout__next_step__order_now__payment_method_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.PAYMENT,
    component: <PaymentContainer_1.default />,
    summaryComponent: <PaymentSummary_1.default summary={true}/>,
};
var EnquiryFormStep = {
    labelId: 'trans__checkout__next_step__customer_information_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.YOUR_DETAILS,
    component: <CustomerInformation_1.default />,
    summaryComponent: <CustomerInformationSummary_1.default />,
};
var IdentityVerificationStep = {
    labelId: 'trans__checkout__next_step__customer_information_label',
    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.IDENTITY_VERIFICATION,
    component: <IdentityVerificationContainer_1.default />,
    summaryComponent: <CustomerInformationSummary_1.default />,
};
exports.JourneysSteps = (_a = {},
    _a[JourneySteps_1.JourneySteps.JourneySelection] = JourneySelectionStep,
    _a[JourneySteps_1.JourneySteps.Accesories] = AccessoriesStep,
    _a[JourneySteps_1.JourneySteps.HeadlessFinance] = HeadlessFinanceStep,
    _a[JourneySteps_1.JourneySteps.Dealer] = DealerStep,
    _a[JourneySteps_1.JourneySteps.Finance] = FinanceStep,
    _a[JourneySteps_1.JourneySteps.FinanceInsurance] = FinanceInsuranceStep,
    _a[JourneySteps_1.JourneySteps.Extras] = ExtrasStep,
    _a[JourneySteps_1.JourneySteps.EnquiryForm] = EnquiryFormStep,
    _a[JourneySteps_1.JourneySteps.IdentityVerification] = IdentityVerificationStep,
    _a[JourneySteps_1.JourneySteps.Payment] = PaymentStep,
    _a);
exports.JourneysLockedSteps = [JourneySteps_1.JourneySteps.FinanceInsurance];
exports.Journeys = [
    {
        title: 'trans__checkout__next_step__enquire_label',
        description: 'trans__checkout__next_step__enquire_description',
        journeyType: globalTypes_1.JourneyType.continue_in_dealership,
        icon: <BubbleHelpIcon_1.default />,
    },
    {
        title: 'trans__checkout__next_step__reserve_your_car_label',
        description: 'trans__checkout__next_step__reserve_your_car_description',
        journeyType: globalTypes_1.JourneyType.reserve_online,
        icon: <CarTvIcon_1.default />,
    },
    {
        title: 'trans__checkout__next_step__order_now_label',
        description: 'trans__checkout__next_step__order_now_description',
        journeyType: globalTypes_1.JourneyType.online_order,
        icon: <CartIcon_1.default />,
    },
    {
        title: 'trans__checkout__next_step__pre_order_now_label',
        description: 'trans__checkout__next_step__pre_order_now_description',
        journeyType: globalTypes_1.JourneyType.pre_order_now,
        icon: <CartIcon_1.default />,
    },
];
exports.DefaultJourneys = [
    {
        journeyType: globalTypes_1.JourneyType.continue_in_dealership,
        steps: [JourneySteps_1.JourneySteps.JourneySelection, JourneySteps_1.JourneySteps.EnquiryForm],
    },
    {
        journeyType: globalTypes_1.JourneyType.reserve_online,
        steps: [JourneySteps_1.JourneySteps.JourneySelection, JourneySteps_1.JourneySteps.EnquiryForm, JourneySteps_1.JourneySteps.Payment],
    },
    {
        journeyType: globalTypes_1.JourneyType.online_order,
        steps: [
            JourneySteps_1.JourneySteps.JourneySelection,
            JourneySteps_1.JourneySteps.FinanceInsurance,
            JourneySteps_1.JourneySteps.EnquiryForm,
            JourneySteps_1.JourneySteps.Payment,
        ],
    },
];
